import { useQueryState } from "context/queryState"
import { useAppSelector } from "reducers/store"

import { API_MAPPING, API_MAPPING_FORM } from "reducers/api-mappings/api-mapping-actions"
import styled from "styled-components"

import ApiApiMappings from "api/ApiApiMappings"
import Spinner from "components/EvtKit/loading-spinner/LoadingSpinner"
import { useCallback } from "react"
import { useParams } from "react-router-dom"

import ExtendedRJSForm from "components/RJSF/ExtendedRJSForm"
import Heading from "components/Typography/Heading"
import { useMutation, useQueryClient } from "react-query"
import { showToast } from "reducers/toast/toast-actions"
import { useAppDispatch } from "reducers/store"
import { useNavigate } from "react-router-dom"
import useHandleApiError from "hooks/useHandleApiErrors"

const Container = styled.div`
  width: 80vw;
  height: 95vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-top: 48px;

  // Space all direct children (use margin top)
  & > * {
    margin-top: 16px;
  }
`

const ApiMappingEdit = () => {
  const params = useParams()
  const appDispatch = useAppDispatch()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  useQueryState(
    [API_MAPPING_FORM, params.id],
    async () => await new ApiApiMappings().getById(params.id),
    API_MAPPING_FORM,
    {
      refetchOnMount: true
    }
  )

  const { data, loading } = useAppSelector((state) => state.apiMapping.apiMappingForm)

  const isUpdating = !!params.id && params.id !== "create"

  function customValidate(formData, errors) {
    if (formData.product === "No products available") {
      errors.product.addError("You need a external product in order to create a endpoint.")
    }

    return errors
  }

  const { getErrorMessageAndShowErrorToast } = useHandleApiError()

  const createForm = useMutation({
    mutationFn: async (data: App.ApiMapping) => {
      return new ApiApiMappings().create(data)
    },
    onSuccess: () => {
      navigate("/api-mappings")
      queryClient.invalidateQueries(API_MAPPING)
      queryClient.invalidateQueries(API_MAPPING_FORM)
      appDispatch(showToast("Endpoint salvo com sucesso", "success"))
    },
    onError: (error) => {
      getErrorMessageAndShowErrorToast(error, "Erro ao criar o endpoint.")
    }
  })

  const updateForm = useMutation({
    mutationFn: async (data: App.ApiMapping) => {
      return new ApiApiMappings().update(data, params.id as string)
    },
    onSuccess: () => {
      navigate("/api-mappings")
      queryClient.invalidateQueries(API_MAPPING)
      queryClient.invalidateQueries(API_MAPPING_FORM)
      appDispatch(showToast("Endpoint atualizado com sucesso", "success"))
    },
    onError: (error) => {
      getErrorMessageAndShowErrorToast(error, "Erro ao salvar o endpoint")
    }
  })

  const handleSubmit = useCallback((data) => {
    if (isUpdating) {
      updateForm.mutate(data.formData)
    } else {
      createForm.mutate(data.formData)
    }
  }, [])

  return (
    <Container>
      <Heading variant="h2">{isUpdating ? "Editar" : "Criar"} Endpoint</Heading>
      {loading && <Spinner />}
      {!loading && (
        <ExtendedRJSForm
          id="tour-options-details-form"
          schema={data.formSchema}
          uiSchema={data.uiSchema}
          formData={data.formData}
          onSubmit={handleSubmit}
          busy={loading}
          customValidate={customValidate}
        />
      )}
    </Container>
  )
}

export default ApiMappingEdit
